export abstract class LoadableResource<T> {
  private resource?: T;
  private loadPromise?: Promise<T>;
  private loaded: boolean = false;
  private loading: boolean = false;

  getResource() {
    if (this.resource === undefined)
      throw new Error("Attempted to access resource before load");
    return this.resource;
  }

  isLoaded() {
    return this.loaded;
  }

  abstract getResourcePromise(): Promise<T>;
  abstract load(): Promise<void>;

  protected async internalResourceLoadSequenceFromFunction(
    loadFunc: () => Promise<T>
  ): Promise<T> {
    if (this.resource !== undefined) return this.resource;
    if (this.loadPromise) return this.loadPromise;
    if (this.loading || this.loaded)
      throw new Error("Broken invarient found...");
    this.loading = true;
    this.loadPromise = loadFunc();
    this.resource = await this.loadPromise;
    this.loading = false;
    this.loaded = true;
    return this.resource;
  }
}
